// utils/gate.js
// Gate：在 open() 前，所有 whenReady() 都會等待；超時會拒絕（避免無窮等待）
export class Gate {
	/**
	 * @param {number} timeout     預設逾時毫秒數（單次呼叫可覆蓋）
	 * @param {number} maxWaiters  允許同時等待的最大數量（防止極端壓力）
	 */
	constructor(timeout = 15000, maxWaiters = 1000) {
		this._ready = false
		this._waiters = []
		this._timeout = timeout
		this._maxWaiters = maxWaiters
	}

	/**
	 * 等待 Gate 開啟；若 timeoutMs > 0 並在該時間內未開啟則丟錯
	 * @param {string} source 呼叫位置
	 * @param {number} timeoutMs 單次呼叫的逾時（預設用建構子值）
	 * @returns {Promise<void>}
	 */
	whenReady(source, timeoutMs = this._timeout) {
		if (this._ready) {
			return Promise.resolve()
		}

		return new Promise((resolve, reject) => {
			if (this._waiters.length >= this._maxWaiters) {
				const err = new Error('Too many waiters')
				err.code = 'GATE_TOO_MANY_WAITERS' // 供攔截器/全域錯誤處理辨識
				reject(err)
				return
			}

			const waiter = { resolve, reject, timeoutId: null }

			if (timeoutMs > 0) {
				waiter.timeoutId = setTimeout(() => {
					const idx = this._waiters.indexOf(waiter)
					if (idx !== -1) this._waiters.splice(idx, 1)
					const err = new Error('Gate open timeout')
					err.code = 'GATE_TIMEOUT'
					err.timeoutMs = timeoutMs
					reject(err)
				}, timeoutMs)
			}

			this._waiters.push(waiter)
		})
	}

	/** 開門：清理所有等待者的 timeout，並逐一 resolve；重入安全 */
	open() {
		if (this._ready) return
		this._ready = true

		const waiters = this._waiters.splice(0)
		for (const w of waiters) {
			if (w.timeoutId) clearTimeout(w.timeoutId)
			// 與 timeout 可能競態，但 Promise 只會結算一次，安全
			w.resolve()
		}
	}
}

// 全域單例：App 開機/初始化用（可依需求調整預設值）
export const bootGate = new Gate(15000, 1000)
